import { TemplateCategory } from '@/components/confluence/templates/template-categories-search';
import { Template } from '@/content/templates/template.types';

// TODO DELETE this once we get data sent to this page on load
// @ts-ignore
export const testCategoriesData: TemplateCategory[] = [
	{
		id: '7ckISKU5UGRFKMEQyFfmH1',
		name: 'Featured',
		urlSlug: 'featured',
		shortDescriptionOneLiner: 'Check out the latest and greatest templates from Confluence Cloud.',
		pageTitle: 'Featured Confluence Templates',
		description: null,
		experiment: false,
	},
	{
		id: '7ckISKU5UGRFKMEQyFfmH2',
		name: 'Partners',
		urlSlug: 'partners',
		shortDescriptionOneLiner: 'Learn how the pros do it with templates from our partners.',
		pageTitle: 'Partner Templates',
		description: null,
		experiment: false,
	},
	{
		id: '3L5l3wY9ZWRYMqVpAewmcG',
		name: 'Business Strategy',
		urlSlug: 'business-strategy',
		shortDescriptionOneLiner:
			'Identify goals, assess risks, and implement business tactics with these business strategy templates.',
		pageTitle: 'Business Strategy Templates',
		description: null,
		experiment: false,
	},
	{
		id: '3L5l3wY9ZWRYMqVpAewmcr',
		name: 'Design',
		urlSlug: 'design',
		shortDescriptionOneLiner:
			'Use Confluence’s collection of design templates to create design systems, brainstorm ideas, and run design sprints like an expert.',
		pageTitle: 'Design Templates',
		description: null,
		experiment: false,
	},
	{
		id: '3L5l3wY9ZWRYMqVpAewmc1',
		name: 'Docs & Reports',
		urlSlug: 'docs-and-reports',
		shortDescriptionOneLiner:
			'Improve documentation and create great reports to share with your team and other stakeholders.',
		pageTitle: 'Docs & Reports Templates',
		description: null,
		experiment: false,
	},
	{
		id: '3L5l3wY9ZWRYMqVpAewmc2',
		name: 'Human Resources',
		urlSlug: 'human-resources',
		shortDescriptionOneLiner:
			'Simplify recruiting and employee development with these Confluence templates for HR pros.',
		pageTitle: 'Human Resources Templates',
		description: null,
		experiment: false,
	},
	{
		id: '3L5l3wY9ZWRYMqVpAewmc3',
		name: 'Marketing & Sales',
		urlSlug: 'marketing-and-sales',
		shortDescriptionOneLiner:
			'Write a creative brief, craft user personas, coordinate campaigns, and a whole lot more. Check out our top marketing and sales templates here.',
		pageTitle: 'Marketing & Sales Templates',
		description: null,
		experiment: false,
	},
	{
		id: '3L5l3wY9ZWRYMqVpAewmc4',
		name: 'Personal',
		urlSlug: 'personal',
		shortDescriptionOneLiner:
			'Jot down notes, organize your work, and much more in the safe space of Confluence.',
		pageTitle: 'Personal Templates',
		description: null,
		experiment: false,
	},
	{
		id: '5K1kNHZzKqwQBpU3XThCQW',
		name: 'Product Management',
		urlSlug: 'product-management',
		shortDescriptionOneLiner:
			'Master the product management lifecycle from brainstorming to launch with templates tailor-made for PMs.',
		pageTitle: 'Product Management Templates',
		description: null,
		experiment: false,
	},
	{
		id: '5K1kNHZzKqwQBpU3XThCQ1',
		name: 'Productivity',
		urlSlug: 'productivity',
		shortDescriptionOneLiner:
			"Keep track of where you're going and what you need to accomplish with our productivity templates, including to-do lists, meeting notes and more.",
		pageTitle: 'Productivity Templates',
		description: null,
		experiment: false,
	},
	{
		id: '5K1kNHZzKqwQBpU3XThCQ2',
		name: 'Project Planning',
		urlSlug: 'project-planning',
		shortDescriptionOneLiner:
			'Oversee projects, report progress, and prepare for project deadlines and launches.',
		pageTitle: 'Project Planning Templates',
		description: null,
		experiment: false,
	},
	{
		id: '5K1kNHZzKqwQBpU3XThCQ3',
		name: 'Software Development / IT',
		urlSlug: 'software-development',
		shortDescriptionOneLiner:
			'Support your engineering team and develop products faster with our software and IT templates.',
		pageTitle: 'Software Development / IT Templates',
		description: null,
		experiment: false,
	},
	{
		id: '5lnoDFfbaQh3DA2Ajm9WSH',
		name: 'Startup',
		urlSlug: 'startup',
		shortDescriptionOneLiner:
			'Get started with resources for early-stage companies to help your team scale.',
		pageTitle: 'Startup Templates',
		description: null,
		experiment: false,
	},
	{
		id: '5lnoDFfbaQh3DA2Ajm9WS1',
		name: 'Teamwork',
		urlSlug: 'teamwork',
		shortDescriptionOneLiner:
			'Monitor the health of your teams and organize meeting minutes and notes.',
		pageTitle: 'Teamwork Templates',
		description: null,
		experiment: false,
	},
] as const;

// @ts-ignore
export const testExperimentCategoriesData: TemplateCategory[] = [
	{
		id: '7ckISKU5UGRFKMEQyFf223',
		name: 'Recommended templates',
		urlSlug: 'recommended',
		shortDescriptionOneLiner:
			'Check out our personalized list of templates relevant to you and your team.',
		pageTitle: 'Recommended templates',
		description: null,
		experiment: false,
	},
	{
		id: '3L5l3wY9ZWRYMqVpAewmc1',
		name: 'Human Resources',
		urlSlug: 'human-resources',
		shortDescriptionOneLiner:
			'Simplify recruiting and employee development with these Confluence templates for HR pros.',
		pageTitle: 'Human Resources Templates',
		description: null,
		experiment: false,
	},
	{
		id: '3L5l3wY9ZWRYMqVpAewmee',
		name: 'Design',
		urlSlug: 'design',
		shortDescriptionOneLiner:
			'Use Confluence’s collection of design templates to create design systems, brainstorm ideas, and run design sprints like an expert.',
		pageTitle: 'Design Templates',
		description: null,
		experiment: false,
	},
	{
		id: '5K1kNHZzKqwQBpU3XThw2Q3',
		name: 'Software Development & IT',
		urlSlug: 'software-development',
		shortDescriptionOneLiner:
			'Support your engineering team and develop products faster with our software and IT templates.',
		pageTitle: 'Software Development / IT Templates',
		description: null,
		experiment: false,
	},
	{
		id: '5K1kNHZzKqwQBpU3XThwww',
		name: 'Product Management',
		urlSlug: 'product-management',
		shortDescriptionOneLiner:
			'Master the product management lifecycle from brainstorming to launch with templates tailor-made for PMs.',
		pageTitle: 'Product Management Templates',
		description: null,
		experiment: false,
	},
] as const;

export const partnerTemplatesDataUrlSlugs = [
	'team-homepage',
	'job-description',
	'experiment-plan-and-results',
	'design-sprint',
	'customer-impact-assessment',
	'project-status',
	'brainstorming',
	'business-plan-one-pager',
	'aws-architecture-diagram',
	'risk-assessment',
	'team-poster',
];

export const testPartnerTemplatesData = [
	{
		templateId: 'tXbjwEb4mL6WURJ4cq411',
		name: 'Team homepage',
		urlSlug: 'team-homepage',
		partnerDescription: 'Invite your organization at large to get to know your team.',
		contributor: {
			name: 'HubSpot',
			logo: [
				{
					name: 'hubspot-logo',
					size: 4833,
					url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/partner-templates/hubspot-logo-full.webp',
					height: 109,
					width: 460,
				},
			],
		},
		previewBlurb: 'Invite your organization at large to get to know your team.',
		templateIcon: {
			name: 'HubSpot logo',
			size: 4833,
			url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/partner-templates/hubspot-logo-full.webp',
			height: 64,
			width: 64,
		},
		partnerImage: {
			name: 'hubspot',
			size: 1137,
			url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-hubspot-media-kit.webp',
			height: 64,
			width: 64,
		},
	},
	{
		templateId: '2WbcCVrA7SH6ZVuXCsyDtu',
		name: 'Job description',
		urlSlug: 'job-description',
		partnerDescription: 'Finding the right talent starts here.',
		contributor: {
			name: 'Indeed',
			logo: [
				{
					name: 'indeed-logo-full',
					size: 74906,
					url: '//images.ctfassets.net/xjcz23wx147q/49VpFL28CtHeNkuSH2F9lP/30d40c925537d3953199ca05ec30a9af/indeed-logo-full.svg',
					height: 201,
					width: 731,
				},
			],
		},
		previewBlurb:
			'Use this template to build job descriptions that will attract the highest quality candidates.',
		templateIcon: {
			name: 'hiring-process',
			size: 6317,
			url: 'https://wac-cdn.atlassian.com/dam/jcr:641d5550-46de-4938-8028-eb39e9c48f82/indeed-logo-full.svg?cdnVersion=1426',
			height: 64,
			width: 64,
		},
		partnerImage: {
			name: 'indeed',
			size: 1137,
			url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-indeed-unsplash.webp',
			height: 64,
			width: 64,
		},
	},
	{
		templateId: 'tXbjwEb4mL6WURJ4cq41D',
		name: 'Experiment plan and results',
		urlSlug: 'experiment-plan-and-results',
		partnerDescription: 'Streamline your process and improve your business.',
		contributor: {
			name: 'Optimizely',
			logo: [
				{
					name: 'optimizely-logo',
					size: 4833,
					url: '//images.ctfassets.net/xjcz23wx147q/6UgZ8U62VhRebuxWTC6fx3/31d9d8888ef58eb6d73cfdb6c3e66570/optimizely-logo.png',
					height: 109,
					width: 460,
				},
			],
		},
		previewBlurb:
			'Document the details of your experiment including your hypothesis, variations, and results.',
		templateIcon: {
			name: 'Optimizely logo',
			size: 420871,
			url: 'https://wac-cdn.atlassian.com/dam/jcr:e2ed4cbc-94fd-494f-a04b-9646b797ef25/optimizely-logo-full.png?cdnVersion=1426',
			height: 64,
			width: 64,
		},
		partnerImage: {
			name: 'optimizely',
			size: 1137,
			url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-optimizely-unsplash.webp',
			height: 64,
			width: 64,
		},
	},
	{
		templateId: 'tXbjwEb4mL6WURJ4cq413',
		name: 'Design sprint ',
		urlSlug: 'design-sprint',
		partnerDescription:
			'Run a well-planned print, understand design problems and brainstorm solutions. ',
		contributor: {
			name: 'Figma',
			logo: [
				{
					name: 'figma-logo',
					size: 4833,
					url: 'https://wac-cdn.atlassian.com/dam/jcr:3a696f17-0629-4a92-895b-cdaf3fdd3d08/figma-logo-full.svg?cdnVersion=1392',
					height: 109,
					width: 460,
				},
			],
		},
		previewBlurb: 'Run a well-planned print, understand design problems and brainstorm solutions. ',
		templateIcon: {
			name: 'figma logo',
			size: 420871,
			url: 'https://wac-cdn.atlassian.com/dam/jcr:3a696f17-0629-4a92-895b-cdaf3fdd3d08/figma-logo-full.svg?cdnVersion=1392',
			height: 64,
			width: 64,
		},
		partnerImage: {
			name: 'figma',
			size: 1137,
			url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-figma-unsplash.webp',
			height: 64,
			width: 64,
		},
	},
	{
		templateId: '38qTifwO0eMcG6r8Idr2c1',
		name: ' Customer impact assessment',
		urlSlug: 'customer-impact-assessment',
		partnerDescription: 'Make a change with zero pain with the right process. ',
		contributor: {
			name: 'ZENDESK',
			logo: [
				{
					name: 'zendesk-logo',
					size: 34708,
					url: 'https://wac-cdn.atlassian.com/dam/jcr:6c868fb8-1f02-467b-b5a5-799502e17d82/zendesk-logo-full.png?cdnVersion=1418',
				},
			],
		},
		previewBlurb: 'Make a change with zero pain with the right process. ',
		templateIcon: {
			name: 'Brainstorming icon',
			size: 9247,
			url: 'https://wac-cdn.atlassian.com/dam/jcr:6c868fb8-1f02-467b-b5a5-799502e17d82/zendesk-logo-full.png?cdnVersion=1418',
			height: 236,
			width: 248,
		},
		partnerImage: {
			name: 'zendesk',
			size: 1137,
			url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-zendesk-unsplash.webp',
			height: 64,
			width: 64,
		},
	},
	{
		templateId: '3iLfGIDUjhn3vSBpnpzcNM',
		name: 'Project status',
		urlSlug: 'project-status',
		partnerDescription:
			'Easily update your teams on project status using Confluence and Jira data.',
		contributor: {
			name: 'Arizona State University',
			logo: [
				{
					name: 'arizona-state-university-logo',
					size: 11030,
					url: '//images.ctfassets.net/xjcz23wx147q/5JVzU07vgxDAgmfK1PQLS6/5ff1f25fd7df230329bc97219c35da6e/arizona-state-university-asu.svg',
					height: 595,
					width: 1813,
				},
			],
		},
		previewBlurb:
			'Easily report progress on your projects to stakeholders using Confluence and Jira together.',
		templateIcon: {
			name: 'project-status-icon',
			size: 12929,
			url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/partner-templates/asu-logo-full.webp',
			height: 64,
			width: 64,
		},
		partnerImage: {
			name: 'arizonastateuniversity',
			size: 1137,
			url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-asu-media-kit.webp',
			height: 64,
			width: 64,
		},
	},
	{
		templateId: '38qTifwO0eMcG6r8Idr2cH',
		name: 'Brainstorming',
		urlSlug: 'brainstorming',
		partnerDescription: ' Lead a super productive brainstorming session.',
		contributor: {
			name: 'MURAL',
			logo: [
				{
					name: 'mural-logo',
					size: 34708,
					url: '//images.ctfassets.net/xjcz23wx147q/6HaL8jfJ8lZV0pPTuFarDS/12db840ecd288b695bf4601c2102c5e2/mural-139x26.svg',
				},
			],
		},
		previewBlurb: 'Lead a super productive brainstorming session',
		templateIcon: {
			name: 'Brainstorming icon',
			size: 9247,
			url: 'https://wac-cdn.atlassian.com/dam/jcr:642ced63-c988-4f5f-9ec4-34e0757d7d61/mural-logo-full.svg?cdnVersion=1426',
			height: 236,
			width: 248,
		},
		partnerImage: {
			name: 'Brainstorming',
			size: 1137,
			url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-mural-media-kit.webp',
			height: 64,
			width: 64,
		},
	},
	{
		templateId: '01p85VZkOsDbJaRMrZjqzW',
		name: 'Business plan one-pager',
		urlSlug: 'business-plan-one-pager',
		partnerDescription: 'Set your strategy (and stick to it) with a short and simple plan.',
		contributor: {
			name: 'Isos Technology',
			logo: [
				{
					name: 'isos-logo',
					size: 7862,
					url: '//images.ctfassets.net/xjcz23wx147q/6sRPBfEdDyxaNiPh5scG7K/d92019fc67cabc1327bd18c5d0a247b5/isos-logo-full.png',
					height: 225,
					width: 800,
				},
			],
		},
		previewBlurb: 'Set your strategy (and stick to it) with a short and simple plan',
		templateIcon: {
			name: 'Isos logo',
			size: 8506,
			url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/partner-templates/isos-logo-full.webp',
			height: 250,
			width: 212,
		},
		partnerImage: {
			name: 'isostech',
			size: 1137,
			url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-isos-unsplash.webp',
			height: 64,
			width: 64,
		},
	},
	{
		templateId: 'Aen4GRrwytCXzfh3VGboA',
		name: 'AWS architecture diagram',
		urlSlug: 'aws-architecture-diagram',
		partnerDescription: 'Visualize your AWS network with this guide from Lucidchart’s.',
		contributor: {
			name: 'Lucidchart',
			logo: [
				{
					name: 'lucidchart-logo-full',
					size: 8025,
					url: '//images.ctfassets.net/xjcz23wx147q/2FoqenBRbSpjDs8tG0842m/aa85152afba56f04c3b2e70e9d1f6022/lucidchart-logo-full.png',
					height: 150,
					width: 600,
				},
				{
					name: 'lucidchat-pictorial-logo',
					size: 2841,
					url: '//images.ctfassets.net/xjcz23wx147q/48Wzj474xufBid0gFLHItY/e8175b3a56c0b6a56063c17e8def0558/aws-architecture-diagram.svg',
					height: 64,
					width: 64,
				},
			],
		},
		previewBlurb: 'Visualize your AWS network with this guide from Lucidchart',
		templateIcon: {
			name: 'lucidchat-pictorial-logo',
			size: 2841,
			url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/partner-templates/lucidchart-logo-full.webp',
			height: 64,
			width: 64,
		},
		partnerImage: {
			name: 'lucidchart',
			size: 1137,
			url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-lucidchart-unsplash.webp',
			height: 64,
			width: 64,
		},
	},
	{
		templateId: '2lGZVe8PSvCrXFIjT4w4tC',
		name: 'Risk assessment matrix',
		urlSlug: 'risk-assessment',
		partnerDescription: 'Identify, prioritize, plan for (and avoid) worst-case scenarios.',
		contributor: {
			name: 'Stiltsoft',
			logo: [
				{
					name: 'stiltsoft-logo-full',
					size: 3822,
					url: '//images.ctfassets.net/xjcz23wx147q/5q6RcuZ7KD8K0DT8OQs2w4/b249a1d8810e85d6f8378464b92d2333/stiltsoft-logo-full.svg',
					height: 63,
					width: 474,
				},
			],
		},
		previewBlurb:
			'Identify and prioritize risks, then define what further actions you need to take to control.',
		templateIcon: {
			name: 'risk-assessment-icon',
			size: 11682,
			url: 'https://wac-cdn.atlassian.com/dam/jcr:05d75cb9-faf0-4ebe-8b11-707adc1dbf58/stiltsoft-logo-full.svg?cdnVersion=1426',
			height: 64,
			width: 64,
		},
		partnerImage: {
			name: 'Stiltsoft',
			size: 1137,
			url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-stiltsoft-unsplash.webp',
			height: 64,
			width: 64,
		},
	},
	{
		templateId: 'tXbjwEb4mL6WURJ4cq412',
		name: 'Team poster',
		urlSlug: 'team-poster',
		partnerDescription: 'Invite your organization at large to get to know your team.',
		contributor: {
			name: 'Atlassian',
			logo: [
				{
					name: 'atlassian-logo',
					size: 4833,
					url: 'https://wac-cdn.atlassian.com/dam/jcr:97f4fdbe-96d6-4c84-9ad3-e6f597d9ba37/logos-Atlassian-horizontal-blue-onecolor-rgb.svg?cdnVersion=1392',
					height: 109,
					width: 460,
				},
			],
		},
		previewBlurb: 'Invite your organization at large to get to know your team.',
		templateIcon: {
			name: 'Atlassian logo',
			size: 420871,
			url: 'https://wac-cdn.atlassian.com/dam/jcr:97f4fdbe-96d6-4c84-9ad3-e6f597d9ba37/logos-Atlassian-horizontal-blue-onecolor-rgb.svg?cdnVersion=1426',
			height: 64,
			width: 64,
		},
		partnerImage: {
			name: 'atlassian',
			size: 1137,
			url: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/partner-atlassian-thumbnail.webp',
			height: 64,
			width: 64,
		},
	},
];

const sampleSteps = {
	id: '',
	collectionSteps: [
		{
			id: '',
			stepDescription: 'Step 1',
		},
		{
			id: '',
			stepDescription: 'Step 2',
		},
		{
			id: '',
			stepDescription: 'Step 3',
		},
	],
};

export const testCollectionsData = [
	{
		collectionId: '3ik7wHavyuXTaGC6kuLdAr',
		aboutThisCollectionHeader: 'About this collection',
		collectionIcon: {
			name: 'Knowledge base icon',
			size: 8155,
			url: '//images.ctfassets.net/xjcz23wx147q/4qkSS5QJ1cT7R5uJbMAqMe/9827806bb0ecd039b5c0ddfceaff63d2/Knowledge_base.svg',
			height: 225,
			width: 208,
		},
		howToUseThisCollection: {
			...sampleSteps,
			collectionSteps: [...sampleSteps.collectionSteps, ...sampleSteps.collectionSteps],
		},
		name: 'Knowledge base templates to empower your ITSM teams',
		oneLinerHeadline: null,
		targetAudience: [],
		targetOrganizationSize: [],
		urlSlug: 'knowledge-base',
	},
	{
		collectionId: '7y4A5e4DukGLpsw2Y82tb6',
		aboutThisCollectionHeader: 'About this collection',
		collectionIcon: {
			name: 'embrace-remote-work',
			size: 17503,
			url: '//images.ctfassets.net/xjcz23wx147q/3E4zNs0kiYj8n1q5b1vYI9/5c75145fe4fd1c24c51cb6d0100eaffe/embrace-remote-work.svg',
			height: 225,
			width: 208,
		},
		howToUseThisCollection: sampleSteps,
		name: 'Embrace remote work',
		oneLinerHeadline: null,
		targetAudience: [],
		targetOrganizationSize: [],
		urlSlug: 'remote-work',
	},
	{
		collectionId: '6y8eul7vGwE0qNYlvmfY6r',
		aboutThisCollectionHeader: 'About this collection',
		collectionIcon: {
			name: 'start-your-product-development-strong',
			size: 8781,
			url: '//images.ctfassets.net/xjcz23wx147q/6g3GrmDju2QqQlJHxbJgaH/3b9cdaf7cb41eda9e1e10dc07b0942a1/start-your-product-development-strong.svg',
			height: 225,
			width: 208,
		},
		howToUseThisCollection: sampleSteps,
		name: 'Start strong with product development',
		oneLinerHeadline: null,
		targetAudience: [],
		targetOrganizationSize: [],
		urlSlug: 'product-launch',
	},
	{
		collectionId: '5tt7SIBtpeXiFpqLeMVNoQ',
		aboutThisCollectionHeader: 'About this collection',
		collectionIcon: {
			name: 'create-effective-designs-at-scale',
			size: 5769,
			url: '//images.ctfassets.net/xjcz23wx147q/7dfqAeL5gybVJPpnsZpeDR/aa38e401dc29ff938a41b5b1eb6d9a64/create-effective-designs-at-scale.svg',
			height: 225,
			width: 208,
		},
		howToUseThisCollection: sampleSteps,
		name: 'Create effective designs at scale',
		oneLinerHeadline: null,
		targetAudience: [],
		targetOrganizationSize: [],
		urlSlug: 'designs-at-scale',
	},
	{
		collectionId: '6iSmUiUUnTA3aUH5J32WWo',
		aboutThisCollection:
			'Developing a marketing strategy is no small feat nor is it something you decide in an afternoon and never look at again. It’s a blueprint for the future growth of your business, your method to creatively in order to stand out from your competition. Use this collection of templates to ensure you have all the information, research, and messaging you need to run a strategy that wins new customers.',
		aboutThisCollectionHeader: 'About this collection',
		collectionIcon: {
			name: 'develop-a-marketing-strategy',
			size: 8119,
			url: '//images.ctfassets.net/xjcz23wx147q/4E52tjazaLHfNuVSPDQJLh/c6a9772f930df5dd8fd6b3541a2de93e/develop-a-marketing-strategy.svg',
			height: 225,
			width: 208,
		},
		howToUseThisCollection: sampleSteps,
		name: 'Templates for developing and executing on marketing strategies',
		oneLinerHeadline: null,
		targetAudience: [],
		targetOrganizationSize: [],
		urlSlug: 'marketing-strategy',
	},
	{
		collectionId: '6uHvaetmIdE2Tg5bgNdkkv',
		aboutThisCollectionHeader: 'About this collection',
		collectionIcon: {
			name: 'Human resource templates collection icon',
			size: 19098,
			url: '//images.ctfassets.net/xjcz23wx147q/5udLs4sXtDAhyJt86QRfL0/af961f5a5ba4c5c5e687258bbfdf5859/Human_resource.svg',
			height: 225,
			width: 208,
		},
		howToUseThisCollection: sampleSteps,
		name: 'Human resource templates collection',
		oneLinerHeadline: null,
		targetAudience: [],
		targetOrganizationSize: [],
		urlSlug: 'hr',
	},
	{
		collectionId: '4SNJ54RF0ffN5vDdEYgZLm',
		aboutThisCollectionHeader: 'About this collection',
		collectionIcon: {
			name: 'Free templates for product managers icon',
			size: 11250,
			url: '//images.ctfassets.net/xjcz23wx147q/4glb7QLDwcptCYw6cUqoLX/8ea9f86a939815d70d8bf23090934ec5/Product_managers.svg',
			height: 225,
			width: 208,
		},
		howToUseThisCollection: sampleSteps,
		name: 'Free templates for product managers',
		oneLinerHeadline: null,
		targetAudience: [],
		targetOrganizationSize: [],
		urlSlug: 'product-managers',
	},
	{
		collectionId: '2dzGklmVHNAr8AoA78It8m',
		aboutThisCollectionHeader: 'About this collection',
		collectionIcon: {
			name: 'Strategic planning icon',
			size: 10750,
			url: '//images.ctfassets.net/xjcz23wx147q/6Bxo0Y6CwvWLTf8zf3D4xm/009f6b02ac599f22d87e44bb437bfe51/Strategic_planning.svg',
			height: 225,
			width: 208,
		},
		howToUseThisCollection: sampleSteps,
		name: 'Strategic planning templates',
		oneLinerHeadline: null,
		targetAudience: [],
		targetOrganizationSize: [],
		urlSlug: 'strategic-planning',
	},
	{
		collectionId: '6vwCMnz8wnVCxQI5Vmw79M',
		aboutThisCollectionHeader: 'About this collection',
		collectionIcon: {
			name: 'Project management icon',
			size: 17700,
			url: '//images.ctfassets.net/xjcz23wx147q/4XP2rbdIeeKMsFH8PhAhAq/40fb29aad42b9c554a5e404f0c53d3a7/Project_management.svg',
			height: 225,
			width: 208,
		},
		howToUseThisCollection: sampleSteps,
		name: 'Project management templates',
		oneLinerHeadline: null,
		targetAudience: [],
		targetOrganizationSize: [],
		urlSlug: 'project-management',
	},
	{
		collectionId: '7dHBMNb4S2pleQYqTKdLH1',
		aboutThisCollectionHeader: 'About this template',
		collectionIcon: {
			name: 'nailing-the-employee-development-lifecycle',
			size: 4413,
			url: '//images.ctfassets.net/xjcz23wx147q/7nEOM0fbrOQjCB87xfljyl/af0da7d687856fb56b24625187905682/nailing-the-employee-development-lifecycle.svg',
			height: 225,
			width: 208,
		},
		howToUseThisCollection: sampleSteps,
		name: 'Employee development templates',
		oneLinerHeadline: null,
		targetAudience: [],
		targetOrganizationSize: [],
		urlSlug: 'employee-development',
	},
];

export const testTemplatesData: Template[] = [
	{
		templateId: '1od1B5ZbkxE7Wj1LF3tJUg',
		name: 'Strategic plan',
		urlSlug: 'annual-plan-one-pager',
		contributor: {
			name: 'Atlassian',
			tagline: 'Connect globally, meet locally. ',
			shortDescription:
				'Atlassian is an enterprise software company that develops products for software developers, project managers, and content management.',
			logo: [
				{
					name: 'Atlassian Logo',
					size: 3121,
					url: '//images.ctfassets.net/xjcz23wx147q/4V5qEnMuSB7f6d3p3Pj18g/f86abb82f4c010a0b2e5f5daa57aed7b/atlassian-logo-gradient-horizontal-blue-cmyk.svg',
					height: 150,
					width: 540,
				},
			],
			industry: [
				{
					name: 'Software & Design',
					shortDescription: null,
				},
			],
		},
		previewBlurb:
			'Capture and present your business strategy to the executive team and board of directors.',
		templateIcon: {
			name: 'business-strategy',
			size: 1123,
			url: '//images.ctfassets.net/xjcz23wx147q/2zGYT0BKy10XKLPS2m7YiJ/b54a2a6632f8a7fa1978cb43c097cf60/business-strategy.svg',
			height: 64,
			width: 64,
		},
		oneLinerHeadline:
			'Present your business vision and help your team understand your strategic plan',
		aboutThisTemplate:
			'<p>The meeting’s scheduled. Your strategy’s ready. Use the business strategy template to focus your thoughts before you present your vision and strategic plan to executive leadership and your team. Once everyone understands your strategy, use our template to organize how you’ll get it done.</p>',
	},
	{
		templateId: '31d4aEberzjkvYKQ8n44Ua',
		name: '4Ls retrospective',
		urlSlug: '4-ls-retrospective',
		previewBlurb: 'Use this template to conduct a 4Ls retrospective with your team.',
		templateIcon: {
			name: '',
			size: 981,
			url: '//images.ctfassets.net/xjcz23wx147q/3mQwck0AMkvTR9OWmbRZ13/62ec77b3a1688d2120c1e98e0eaf9470/4-ls-retrospective.svg',
			height: 64,
			width: 64,
		},
		contributor: { name: 'Atlassian' },
		oneLinerHeadline:
			'Present your business vision and help your team understand your strategic plan',
		aboutThisTemplate:
			'<p>The meeting’s scheduled. Your strategy’s ready. Use the business strategy template to focus your thoughts before you present your vision and strategic plan to executive leadership and your team. Once everyone understands your strategy, use our template to organize how you’ll get it done.</p>',
	},
	{
		oneLinerHeadline:
			'Visually map project elements and phases to enhance collaboration, creativity, and clear communication.',
		templateId: '5TmCRGGKBO787ikpmuFmdC',
		name: 'Storyboard',
		urlSlug: 'storyboard',
		pluginModuleKey: 'whiteboard:storyboard',
		contributor: {
			name: 'Atlassian',
			logo: [
				{
					name: 'Atlassian Logo',
					size: 3121,
					url: '//images.ctfassets.net/xjcz23wx147q/4V5qEnMuSB7f6d3p3Pj18g/953d475eb4c5fb023b07c30b8ef0ef05/atlassian-logo-gradient-horizontal-blue-cmyk.svg',
					description: 'Atlassian',
					contentType: 'image/svg+xml',
					height: 150,
					width: 540,
				},
			],
		},
		previewBlurb:
			'Visually map project elements and phases to enhance collaboration, creativity, and clear communication.',
		templateIcon: {
			name: 'orange compass',
			size: 1069,
			url: '//images.ctfassets.net/xjcz23wx147q/5mHEuKFbJaShSUXs9rT7r/8bc6b01bc0201b69bea45b136e31cb71/orange_compass.svg',
			description: 'orange compass',
			contentType: 'image/svg+xml',
			height: 64,
			width: 64,
		},
	},
	{
		oneLinerHeadline:
			'Determine the root cause of an issue so you can correct it and prevent it from happening again.',
		templateId: '2RaEEfqb3kdvsAjzmwsAhp',
		name: 'Root cause analysis',
		urlSlug: 'root-cause-analysis',
		pluginModuleKey: 'whiteboard:root-cause-analysis',
		contributor: {
			name: 'Atlassian',
			logo: [
				{
					name: 'Atlassian Logo',
					size: 3121,
					url: '//images.ctfassets.net/xjcz23wx147q/4V5qEnMuSB7f6d3p3Pj18g/953d475eb4c5fb023b07c30b8ef0ef05/atlassian-logo-gradient-horizontal-blue-cmyk.svg',
					description: 'Atlassian',
					contentType: 'image/svg+xml',
					height: 150,
					width: 540,
				},
			],
		},
		previewBlurb:
			'Determine the root cause of an issue so you can correct it and prevent it from happening again.',
		templateIcon: {
			name: 'root cause',
			size: 1530,
			url: '//images.ctfassets.net/xjcz23wx147q/1Viyd8zZkdQFrako1yDQvU/d4cdffc5fdac2c3a982dc2568fc36c3f/root_cause.svg',
			description: 'root cause',
			contentType: 'image/svg+xml',
			height: 64,
			width: 64,
		},
	},
	{
		oneLinerHeadline: 'Engage your stakeholders with a compelling executive summary.',
		templateId: '5VmMjamQzV7R3Kc8s8j6Dc',
		name: 'Executive summary',
		urlSlug: 'executive-summary',
		pluginModuleKey: 'whiteboard:executive-summary',
		contributor: {
			name: 'Atlassian',
			logo: [
				{
					name: 'Atlassian Logo',
					size: 3121,
					url: '//images.ctfassets.net/xjcz23wx147q/4V5qEnMuSB7f6d3p3Pj18g/953d475eb4c5fb023b07c30b8ef0ef05/atlassian-logo-gradient-horizontal-blue-cmyk.svg',
					description: 'Atlassian',
					contentType: 'image/svg+xml',
					height: 150,
					width: 540,
				},
			],
		},
		previewBlurb: 'Engage your stakeholders with a compelling executive summary.',
		templateIcon: {
			name: 'executive summary',
			size: 979,
			url: '//images.ctfassets.net/xjcz23wx147q/7mkcp70u0q1S5BhJjb86Zb/efabd5726217eda0b42788133bfc1dda/colorkit__1_.svg',
			description: 'executive summary',
			contentType: 'image/svg+xml',
			height: 64,
			width: 64,
		},
	},
	{
		oneLinerHeadline: 'Visualize and manage stakeholder relationships effortlessly.',
		templateId: 'UdR3Eu5xU9Fqn5czzy12f',
		name: 'Stakeholder mapping',
		urlSlug: 'stakeholder-mapping',
		pluginModuleKey: 'whiteboard:stakeholder-mapping',
		contributor: {
			name: 'Atlassian',
			logo: [
				{
					name: 'Atlassian Logo',
					size: 3121,
					url: '//images.ctfassets.net/xjcz23wx147q/4V5qEnMuSB7f6d3p3Pj18g/953d475eb4c5fb023b07c30b8ef0ef05/atlassian-logo-gradient-horizontal-blue-cmyk.svg',
					description: 'Atlassian',
					contentType: 'image/svg+xml',
					height: 150,
					width: 540,
				},
			],
		},
		previewBlurb: 'Visualize and manage stakeholder relationships effortlessly.',
		templateIcon: {
			name: 'stakeholder',
			size: 1454,
			url: '//images.ctfassets.net/xjcz23wx147q/3GljwrDpF9T38tv5DGazZD/1653b6bb09c4d5b9f40d6c22fab175dc/colorkit__2_.svg',
			description: 'stakeholder',
			contentType: 'image/svg+xml',
			height: 64,
			width: 64,
		},
	},
	{
		oneLinerHeadline:
			'Outline tasks, deadlines, and responsibilities to streamline project management.',
		templateId: '2gS1aySwQ5QxchfO9w40tD',
		name: 'Action plan',
		urlSlug: 'action-plan',
		pluginModuleKey: 'whiteboard:action-plan',
		contributor: {
			name: 'Atlassian',
			logo: [
				{
					name: 'Atlassian Logo',
					size: 3121,
					url: '//images.ctfassets.net/xjcz23wx147q/4V5qEnMuSB7f6d3p3Pj18g/953d475eb4c5fb023b07c30b8ef0ef05/atlassian-logo-gradient-horizontal-blue-cmyk.svg',
					description: 'Atlassian',
					contentType: 'image/svg+xml',
					height: 150,
					width: 540,
				},
			],
		},
		templatePreview: [
			{
				name: 'Action plan Template',
				size: 1367267,
				url: '//images.ctfassets.net/xjcz23wx147q/4Rs7ZxIGnrW4ylftHINTZn/71b9e1552b2e4f8bb8f03d59b0efcd70/Action_plan_Template.png',
				description: '',
				contentType: 'image/png',
				height: 3956,
				width: 5590,
			},
		],
		previewBlurb:
			'Outline tasks, deadlines, and responsibilities to streamline project management.',
		templateIcon: {
			name: 'action plan',
			size: 1763,
			url: '//images.ctfassets.net/xjcz23wx147q/ydw9xcNPenHDtZdqRehfy/2d946d9d9892aec163dde14dd02b2373/colorkit.svg',
			description: 'action plan',
			contentType: 'image/svg+xml',
			height: 64,
			width: 64,
		},
		category: [
			{
				id: '2y7zzkEt4A2t7p38WvTdVk',
				name: 'Project Planning',
				urlSlug: 'project-planning',
				shortDescriptionOneLiner:
					'Oversee projects, report progress, and prepare for project deadlines and launches.',
				description: null,
				experiment: false,
			},
			{
				id: '5WiLnaoQfSGi9MQAx9C3qP',
				name: 'Productivity',
				urlSlug: 'productivity',
				shortDescriptionOneLiner:
					"Keep track of where you're going and what you need to accomplish with our productivity templates, including to-do lists, meeting notes and more.",
				description: null,
				experiment: false,
			},
		],
		templateType: [
			{
				id: '1HlskYfRNciSnQ02SDhCPs',
				templateTypeName: 'Whiteboard',
			},
		],
	},
	{
		oneLinerHeadline:
			'Aid collaboration and decision-making by visualizing areas of overlap and differences ',
		templateId: '5XrDBPLAS4fuGMwYYyogGz',
		name: 'Venn diagram',
		urlSlug: 'venn-diagram',
		pluginModuleKey: 'whiteboard:venn-diagram',
		contributor: {
			name: 'Atlassian',
			logo: [
				{
					name: 'Atlassian Logo',
					size: 3121,
					url: '//images.ctfassets.net/xjcz23wx147q/4V5qEnMuSB7f6d3p3Pj18g/953d475eb4c5fb023b07c30b8ef0ef05/atlassian-logo-gradient-horizontal-blue-cmyk.svg',
					description: 'Atlassian',
					contentType: 'image/svg+xml',
					height: 150,
					width: 540,
				},
			],
		},
		previewBlurb:
			'Aid collaboration and decision-making by visualizing areas of overlap and differences ',
		templateIcon: {
			name: 'lightbulb',
			size: 1629,
			url: '//images.ctfassets.net/xjcz23wx147q/4r4KW9rTM9KJbI7qAWDlhg/8b0253f2344945c91d6ffe04338a71b9/red_light_bulb.svg',
			description: 'red lighbulb',
			contentType: 'image/svg+xml',
			height: 64,
			width: 64,
		},
	},
	{
		oneLinerHeadline:
			'Visually organize goals and align teams with strategic objectives using images, quotes, and critical ideas.',
		templateId: '4TXUuBydISenQDDVGqPspt',
		name: 'Vision board',
		urlSlug: 'vision-board',
		pluginModuleKey: 'whiteboard:vision-board',
		contributor: {
			name: 'Atlassian',
			logo: [
				{
					name: 'Atlassian Logo',
					size: 3121,
					url: '//images.ctfassets.net/xjcz23wx147q/4V5qEnMuSB7f6d3p3Pj18g/953d475eb4c5fb023b07c30b8ef0ef05/atlassian-logo-gradient-horizontal-blue-cmyk.svg',
					description: 'Atlassian',
					contentType: 'image/svg+xml',
					height: 150,
					width: 540,
				},
			],
		},
		previewBlurb:
			'Visually organize goals and align teams with strategic objectives using images, quotes, and critical ideas.',
		templateIcon: {
			name: 'vision green',
			size: 1161,
			url: '//images.ctfassets.net/xjcz23wx147q/12Z7neu8XssW0wqDevegjB/76146c9c3da7e57d155a8ef6d6e3fbbb/vision_green.svg',
			description: 'green eye',
			contentType: 'image/svg+xml',
			height: 64,
			width: 64,
		},
	},
	{
		oneLinerHeadline:
			'Visualize complex ideas and structure thoughts and relationships clearly with a concept map.',
		templateId: 'myk4F2b7OpOyOPecvKG4Z',
		name: 'Concept map',
		urlSlug: 'concept-map',
		pluginModuleKey: 'whiteboard:concept-map',
		contributor: {
			name: 'Atlassian',
			logo: [
				{
					name: 'Atlassian Logo',
					size: 3121,
					url: '//images.ctfassets.net/xjcz23wx147q/4V5qEnMuSB7f6d3p3Pj18g/953d475eb4c5fb023b07c30b8ef0ef05/atlassian-logo-gradient-horizontal-blue-cmyk.svg',
					description: 'Atlassian',
					contentType: 'image/svg+xml',
					height: 150,
					width: 540,
				},
			],
		},
		templatePreview: [
			{
				name: 'Concept Map',
				size: 1196608,
				url: '//images.ctfassets.net/xjcz23wx147q/4E2On1jD8u0ACoLrRLtoEI/98fc5ff96e6c617ece8171ed6b26a72c/Concept_Map.png',
				description: '',
				contentType: 'image/png',
				height: 3344,
				width: 5446,
			},
		],
		previewBlurb:
			'Visualize complex ideas and structure thoughts and relationships clearly with a concept map.',
		templateIcon: {
			name: 'Writing guidelines template icon',
			size: 3257,
			url: '//images.ctfassets.net/xjcz23wx147q/3ISJnVflfZMmHRCkz7pgnY/11e3157b66407a88a8efd9c5f4d05c02/Screenshot_2024-01-22_at_3.42.30_PM.png',
			description: 'Writing guidelines template icon',
			contentType: 'image/png',
			height: 110,
			width: 112,
		},
	},
];

export const testMlTemplateIds: string[] = testTemplatesData.map((template) => template.templateId);
